export default {
  baseUrl: {
    // dev: 'http://devdb.1000classes.com/bmcserver/',
    // pro: 'http://devdb.1000classes.com/bmcserver/',
    dev: 'https://server.1000classes.com/bmcserver/',
    pro: 'https://server.1000classes.com/bmcserver/',

  },
  cookieExpires: 1, // day
  accesstokenCookieExpires: 7200, //second
  qywx: {
    appId: 'ww35b2ee58ec905a9d',
    agentId: '1000002',
  },
  fdictionaryid: '38CE11BE-0542-4D5D-B3B8-256CF1E2674C',
  callbackUrl: 'https://bmcwx.bmcedu.net/#/callback',
  whiteList: ['/Error'],
}
